import React from 'react'
import { useNavigate } from 'react-router-dom'
import Button from 'components/_UI/Button'
import Modal from 'components/_UI/Modal'
import Text from 'components/_UI/Text'
import { useAuth } from 'context/auth/Auth'
import { useUser } from 'context/user/User'
import paths from 'routes/paths'
import colors from 'theme/colors'
import routeParams from 'theme/routeParams'
import { enterProducerPanel } from './enterProducerPanel'
import useAcceptedInviteRedirect from './useAcceptedInviteRedirect'

/**
 * Resposta do link do e-mail de convite de equipe. Quem aceita vai direto para
 * o painel do produtor (useAcceptedInviteRedirect): como membro, se a equipe
 * liberou o painel, ou como ela mesma, nos eventos que a equipe liberou. Este
 * modal só avisa enquanto a pessoa está de saída, e traz recusa e erro.
 */
export default function TeamInviteAlert({ visible, data, onClose }) {
    const navigate = useNavigate()
    const { isAuth } = useAuth()
    const { user } = useUser()

    const accesses = user?.producer_panel_access || []
    const access = accesses.find((item) => String(item.producer_id) === String(data?.producerId)) || accesses[0]

    const { redirecting } = useAcceptedInviteRedirect({
        active: !!visible && data?.type == 'accept',
        producerId: data?.producerId,
        inviteParams: new URLSearchParams({
            [routeParams.teams.invite]: 'accept',
            [routeParams.teams.inviteTeamName]: data?.teamName || '',
            [routeParams.teams.inviteProducer]: data?.producerId || '',
        }),
    })

    function openPanel() {
        onClose()
        enterProducerPanel(access, { preferEvents: true })
    }

    function login() {
        onClose()
        navigate(paths.login)
    }

    if (redirecting) return null

    return (
        <Modal isOpen={!!visible} closeButton={true} onClose={onClose}>
            {
                data?.type == 'accept' && (
                    <>
                        <Text name='normal' type='bold' color={colors.successLight}>
                            Convite aceito
                        </Text>

                        <Text color={colors.night}>
                            Parabéns! Agora você faz parte da equipe <b>"{data?.teamName}"</b>
                            {isAuth ? '. O acesso ao painel do produtor já está liberado pra você.' : '. Entre na sua conta para acessar o painel do produtor.'}
                        </Text>

                        {
                            !isAuth && (
                                <Button variant='lightBlue' category='roundedBorded' marginTop={'16px'} onClick={login}>
                                    Entrar
                                </Button>
                            )
                        }

                        {
                            isAuth && access && (
                                <Button variant='lightBlue' category='roundedBorded' marginTop={'16px'} onClick={openPanel}>
                                    Acessar painel do produtor
                                </Button>
                            )
                        }
                    </>
                )
            }

            {
                data?.type == 'reject' && (
                    <>
                        <Text name='normal' type='bold' color={colors.danger}>
                            Convite recusado
                        </Text>

                        <Text color={colors.night}>
                            Você recusou o convite para entrar na equipe <b>"{data?.teamName}"</b>.
                        </Text>
                    </>
                )
            }

            {
                data?.type == 'error' && (
                    <>
                        <Text name='normal' type='bold' color={colors.danger}>
                            Ocorreu um erro
                        </Text>

                        <Text color={colors.night}>
                            Ocorreu um erro inesperado durante o seu convite, entre em contato com o responsável da equipe.
                        </Text>
                    </>
                )
            }
        </Modal>
    )
}
